import React from 'react'
import styled from 'styled-components'
import { Trash } from '@styled-icons/boxicons-regular/Trash'

export const Table = styled.table`
  width: 100%;
`

export const THead = styled.thead``

export const TBody = styled.tbody``

export const THeadTR = styled.tr``

export const TBodyTR = styled.tr`
  &:nth-child(odd) {
    background-color: #f0f0f0;
  }

  &:nth-child(even) {
    background-color: #ffffff;
  }

  &:hover {
    border-style: solid;
    border-color: red;
  }
`

export const TH = styled.th`
  padding: 9px 4px;
  color: #666666;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
`

export const TD = styled.td`
  padding: 9px 4px;
  color: #666666;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
`

const WrapperIcon = styled.span`
  display: flex;
  justify-content: center;
  width: 100%;
`

const TrashStyled = styled(Trash)`
  color: red;
  cursor: pointer;
`

export const TrashButton = ({ handleClick }) => (
  <WrapperIcon>
    <TrashStyled onClick={handleClick} size={24} />
  </WrapperIcon>
)
